import axios from 'axios'

let gpuModels = []

export const getGpuModels = async () => {
  try {
    if (gpuModels.length) {
      return gpuModels
    }
    const response = await axios.get('/ui/gpu-models.json')
    gpuModels = response.data
    return gpuModels
  } catch (error) {
    console.error(error)
    return []
  }
}

export const getPassthroughObject = (
  passthrough: string,
  srIOVDevice: boolean = false,
  gpuModels,
) => {
  const passthroughObject = gpuModels.find((model) => model.name === passthrough)

  if (!passthroughObject) {
    return null
  }

  // TODO - This is a temporary fix for SR-IOV devices for June Release
  if (srIOVDevice) {
    return {
      ...passthroughObject,
      deviceType: 'type-PF', //SR-IOV Device
    }
  }
  return passthroughObject
}
